export const HOMEPAGE_HERO_DARK_BG =
  "bg-gradient-to-b from-secondary to-primary-500";
export const HOMEPAGE_HERO_LIGHT_BG =
  "bg-gradient-to-b from-putty-200 to-putty-400";
export const HOMEPAGE_HERO_TEXT_COLOR = "#fff";
